import {
  ACCOUNT_MANAGER,
  ADMIN,
  CALCULATOR_USER_ROLES_DE,
  EXTERNAL_USER_ROLES_DE,
  INTERNAL_USER_ROLES_DE,
  MANUFACTURER,
  PREPRESS_EMPLOYEE,
  SALES_MANAGER,
  ADMIN_US,
  KEY_USER_US,
  USA_ROLES,
} from "./shared/model/roles";

export const navigation_us = [
  {
    text: "My P3",
    path: "/",
    icon: "home",
    allowedRoles: [...USA_ROLES],
  },
  {
    text: "Calculator",
    icon: "money",
    path: "/calculator",
    allowedRoles: [...USA_ROLES],
  },
  {
    text: "Administration",
    icon: "folder",
    allowedRoles: [ADMIN_US, KEY_USER_US],
    items: [
      {
        text: "Publisher",
        icon: "box",
        path: "/organizations",
        allowedRoles: [ADMIN_US],
      },
      {
        text: "Products",
        icon: "folder",
        allowedRoles: [ADMIN_US, KEY_USER_US],
        items: [
          {
            text: "Print & Bind",
            icon: "product",
            path: "/product",
            allowedRoles: [ADMIN_US, KEY_USER_US],
          },
          {
            text: "Components",
            icon: "unselectall",
            path: "/components",
            allowedRoles: [ADMIN_US],
          },
        ],
      },
      {
        text: "Options",
        icon: "detailslayout",
        path: "/option",
        allowedRoles: [ADMIN_US, KEY_USER_US],
      },
      {
        text: "Option Mapping",
        icon: "increaseindent",
        path: "/option-mapping",
        allowedRoles: [ADMIN_US, KEY_USER_US],
      },
      {
        text: "Paper Management",
        icon: "increaseindent",
        path: "/paper-management",
        allowedRoles: [ADMIN_US, KEY_USER_US],
      },
      {
        text: "User",
        icon: "user",
        path: "/user",
        allowedRoles: [ADMIN_US],
      },
      /*
      {
        text: "Papers",
        icon: "file",
        path: "/papers",
        allowedRoles: [ADMIN_US],
      },
       */
    ],
  },
  {
    text: "Archived",
    icon: "unlock",
    allowedRoles: [ADMIN_US],
    items: [
      {
        text: "Calculator (Archived)",
        icon: "money",
        path: "/calculator-legacy",
        allowedRoles: [ADMIN_US],
      },
    ],
  },
];
